<!--首页-->
<template>
  <div class="container">
    <div class="sidebar">
      <div class="sidebar-box">
        <div class="sidebar-box-body">
          <h4 class="sidebar-title">服务分类</h4>
          <el-menu
              :default-active="activeCategory"
              class="service-menu"
              unique-opened
              @select="handleMenuSelect"
          >
            <el-sub-menu
                v-for="(category, catIndex) in serviceCategories"
                :key="category.category_id || catIndex"
                :index="String(category.category_id || catIndex)"
            >
              <template #title>
                <span>{{ category.category }}</span>
              </template>
              <el-sub-menu
                  v-for="(subCategory, subIndex) in category.children"
                  :key="subCategory.sub_category_id || subIndex"
                  :index="`${category.category_id || catIndex}-${subCategory.sub_category_id || subIndex}`"
              >
                <template #title>
                  <span>{{ subCategory.sub_category }}</span>
                </template>
                <el-menu-item
                    v-for="(model, modelIndex) in subCategory.children"
                    :key="model.model_id || modelIndex"
                    :index="`${category.category_id || catIndex}-${subCategory.sub_category_id || subIndex}-${model.model_id || modelIndex}`"
                >
                  <span>{{ model.brand_name }}-{{ model.model_name }}</span>
                </el-menu-item>
              </el-sub-menu>
            </el-sub-menu>
          </el-menu>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="carousel">
        <swiper
            :modules="swiperModules"
            :slides-per-view="1"
            :space-between="0"
            :pagination="{ clickable: true }"
            :autoplay="{ delay: 3000, disableOnInteraction: false }"
            :loop="carouselItems.length > 1"
            class="carousel-swiper"
        >
          <swiper-slide v-for="(item, index) in carouselItems" :key="index">
            <div class="carousel-image">
              <img :src="item" alt="轮播图"/>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="card">
        <div class="card-top">
          <div class="card-title">热门服务</div>
          <div class="card-description">快速解决您的设备问题</div>
        </div>
        <div class="card-body">
          <div class="service-row">
            <div v-for="service in services" :key="service.id" class="service-col">
              <div
                  class="service-item"
                  :class="{ popular: service.isPopular }"
                  :style="{
                  backgroundImage: 'url(' + service.image + ')',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center center'
                }"
              >
                <div class="service-card-body">
                  <div class="service-bg-mask"></div>
                  <div class="service-content">
                    <div v-if="service.isPopular" class="popular-badge">热门</div>
                    <div class="service-icon" :style="{ color: service.color }">
                      <el-icon v-if="service.icon" :size="40">
                        <component :is="service.icon"/>
                      </el-icon>
                    </div>
                    <h3>{{ service.title }}</h3>
                    <p>{{ service.description }}</p>
                    <div class="service-price">{{ service.price }}</div>
                    <button
                        type="button"
                        class="service-btn"
                        :style="{ backgroundColor: service.color, borderColor: service.color }"
                        @click="handleServiceClick(service.id)"
                    >
                      <span>{{ service.buttonText }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-top">
          <div class="section-title"><span>服务数据</span><small>值得信赖的服务平台</small></div>
        </div>
        <div class="card-body">
          <div class="stat-row">
            <div v-for="stat in stats" :key="stat.id" class="stat-col">
              <div class="stat-item">
                <div class="stat-icon" :style="{ color: stat.color }">
                  <el-icon v-if="stat.icon" :size="40">
                    <component :is="stat.icon"/>
                  </el-icon>
                </div>
                <div class="stat-content">
                  <div class="stat-title">{{ stat.title }}</div>
                  <div class="stat-value" :style="{ color: stat.color }">{{ stat.value }}<span>+</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-top">
          <div class="section-title"><span>客户评价</span><small>听听客户怎么说</small></div>
        </div>
        <div class="card-body">
          <div class="testimonial-row">
            <div v-for="testimonial in testimonials" :key="testimonial.id" class="testimonial-col">
              <div class="testimonial-item">
                <div class="testimonial-header">
                  <div class="testimonial-avatar" style="width: 3rem; height: 3rem; font-size: 1.5rem;">
                    <el-icon :size="24">
                      <User/>
                    </el-icon>
                  </div>
                  <div class="testimonial-info">
                    <h4>{{ testimonial.name }}</h4>
                    <p>{{ testimonial.company }}</p>
                    <div class="rating">
                      <el-icon v-for="i in 5" :key="i" :size="16" style="color: rgb(250, 173, 20);">
                        <StarFilled/>
                      </el-icon>
                    </div>
                  </div>
                </div>
                <p class="testimonial-content">"{{ testimonial.content }}"</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-top">
          <div class="section-title"><span>服务特色</span><small>四大核心服务，全方位保障</small></div>
        </div>
        <div class="card-body">
          <div class="feature-row">
            <div v-for="feature in features" :key="feature.id" class="feature-col">
              <div class="feature-item" :style="{ borderTopColor: feature.color }" style="cursor: pointer;">
                <div class="feature-icon" :style="{ color: feature.color }">
                  <el-icon v-if="feature.icon" :size="40">
                    <component :is="feature.icon"/>
                  </el-icon>
                </div>
                <h3>{{ feature.title }}</h3>
                <p>{{ feature.description }}</p>
                <div class="feature-details">
                  <span v-for="tag in feature.tags" :key="tag" class="feature-tag">{{ tag }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--      <div class="card contact-card">-->
      <!--        <div class="card-body">-->
      <!--          <div class="contact-row">-->
      <!--            <div class="contact-col">-->
      <!--              <div class="contact-info">-->
      <!--                <h2>需要帮助？</h2>-->
      <!--                <p>我们的专业团队随时为您提供支持</p>-->
      <!--                <div class="contact-methods">-->
      <!--                  <div class="contact-method">-->
      <!--                    <el-icon :size="18">-->
      <!--                      <Phone/>-->
      <!--                    </el-icon>-->
      <!--                    <span>4008768770</span>-->
      <!--                  </div>-->
      <!--                  <div class="contact-method">-->
      <!--                    <el-icon :size="18">-->
      <!--                      <Clock/>-->
      <!--                    </el-icon>-->
      <!--                    <span>7×24小时服务</span>-->
      <!--                  </div>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--            &lt;!&ndash;              <div class="contact-col">&ndash;&gt;-->
      <!--            &lt;!&ndash;                <div class="contact-actions">&ndash;&gt;-->
      <!--            &lt;!&ndash;                  <button type="button" class="contact-btn contact-btn-primary" @click="call">&ndash;&gt;-->
      <!--            &lt;!&ndash;                    <span>立即咨询</span>&ndash;&gt;-->
      <!--            &lt;!&ndash;                  </button>&ndash;&gt;-->
      <!--            &lt;!&ndash;                  <button type="button" class="contact-btn contact-btn-secondary" @click="openCustomerService">&ndash;&gt;-->
      <!--            &lt;!&ndash;                    <el-icon :size="18"><ChatLineRound /></el-icon>&ndash;&gt;-->
      <!--            &lt;!&ndash;                    <span>客服中心</span>&ndash;&gt;-->
      <!--            &lt;!&ndash;                  </button>&ndash;&gt;-->
      <!--            &lt;!&ndash;                </div>&ndash;&gt;-->
      <!--            &lt;!&ndash;              </div>&ndash;&gt;-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <div class="right-panel">
      <!--      <div class="panel-box latest-order-box">-->
      <!--        <div class="panel-box-body">-->
      <!--          <div class="panel-box-header">-->
      <!--            <el-icon class="panel-box-header-icon" :size="18">-->
      <!--              <Tools/>-->
      <!--            </el-icon>-->
      <!--            <h5 class="panel-box-header-title">最新工单</h5>-->
      <!--          </div>-->
      <!--          <div class="login-prompt">-->
      <!--            <div class="login-avatar">-->
      <!--              <el-icon :size="24">-->
      <!--                <User/>-->
      <!--              </el-icon>-->
      <!--            </div>-->
      <!--            <div class="prompt-details">-->
      <!--              <h3>HI，欢迎来到智维驿</h3>-->
      <!--              <p>登录后查看您的工单信息</p>-->
      <!--            </div>-->
      <!--            <button type="button" class="btn btn-primary btn-block" @click="goToLogin">-->
      <!--              <span>登录/注册</span>-->
      <!--            </button>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="panel-box nav-box">
        <div class="panel-box-top">
          <div class="panel-box-title">快速导航</div>
        </div>
        <div class="panel-box-body">
          <ul class="nav-list">
            <li v-for="nav in navItems" :key="nav.id" class="nav-item" @click="handleNavClick(nav)">
              <div class="nav-icon">
                <el-icon v-if="nav.icon" :size="20">
                  <component :is="nav.icon"/>
                </el-icon>
              </div>
              <div class="nav-content">
                <div class="nav-title">{{ nav.title }}</div>
                <div class="nav-desc">{{ nav.desc }}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="panel-box customer-service-box">
        <div class="panel-box-body">
          <div class="service-info">
            <img :src="require('@/assets/images/公众号二维码.jpg')" alt="公众号二维码"/>
          </div>
          <div class="service-details">
            <p>关注公众号获取服务</p>
          </div>
        </div>
      </div>
      <div class="panel-box promise-box">
        <div class="panel-box-top">
          <div class="panel-box-title">服务承诺</div>
        </div>
        <div class="panel-box-body">
          <div v-for="promise in promises" :key="promise.id" class="promise-item">
            <div class="promise-icon">
              <el-icon :size="12">
                <CircleCheck/>
              </el-icon>
            </div>
            <div class="promise-text">{{ promise.text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.container {
  display: flex;
  padding-top: 12rem;
  background: #f5f6fa;
  justify-content: center;
  gap: 1rem;
}

.sidebar {
  width: 14rem;
  flex-shrink: 0;
  position: sticky;
  align-self: flex-start;
  height: fit-content;
}

.sidebar-box {
  background: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.1);
}

.sidebar-box-body {
  padding: 1.25rem 0;
}

.sidebar-title {
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
  color: #333;
  text-align: center;
}

.service-menu {
  border: none;
  background: transparent;
  overflow: hidden;
}

.service-menu :deep(.el-sub-menu__title),
.service-menu :deep(.el-menu-item) {
  padding: 0.75rem 1rem;
  height: auto;
  line-height: 1.5;
  border-radius: 0.25rem;
  margin-bottom: 0.25rem;
  transition: all 0.3s;
}

.service-menu :deep(.el-sub-menu__title:hover),
.service-menu :deep(.el-menu-item:hover) {
  background: #f0f0f0;
  color: #1890ff;
}

.service-menu :deep(.el-menu-item.is-active) {
  background: #e6f7ff;
  color: #1890ff;
}

.service-menu :deep(.el-sub-menu.is-opened > .el-sub-menu__title) {
  color: #1890ff;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
  background: #e6f7ff;
}

.service-menu :deep(.el-menu-item),
.service-menu :deep(.el-sub-menu__title) {
  font-size: 0.875rem;
}

.service-menu :deep(.el-sub-menu__title span),
.service-menu :deep(.el-menu-item span) {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.service-menu :deep(.el-sub-menu .el-menu-item) {
  padding-left: 2rem !important;
  font-size: 0.8125rem;
}

.service-menu :deep(.el-sub-menu .el-sub-menu .el-menu-item) {
  padding-left: 3rem !important;
  font-size: 0.75rem;
}

.service-menu :deep(.el-icon) {
  margin-right: 0.5rem;
  font-size: 1rem;
}

.main {
  width: 60rem;
  flex-shrink: 0;
}

.carousel {
  width: 60rem;
  height: 25rem;
  background: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
}

.carousel-swiper {
  width: 100%;
  height: 100%;
}

.carousel-swiper .swiper-slide {
  width: 100%;
  height: 100%;
}

.carousel-image {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Swiper 分页指示器样式 */
.carousel-swiper :deep(.swiper-pagination) {
  bottom: 0.75rem;
}

.carousel-swiper :deep(.swiper-pagination-bullet) {
  width: 1rem;
  height: 0.25rem;
  border-radius: 0.125rem;
  background: rgba(255, 255, 255, 0.5);
  opacity: 1;
  transition: all 0.3s;
}

.carousel-swiper :deep(.swiper-pagination-bullet-active) {
  background: #fff;
  width: 1.5rem;
}

.card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin: 1rem 0;
}

.card-body {
  padding: 1.5rem;
  border-radius: 0 0 8px 8px;
}

.card-top {
  padding: 1.5rem 1.5rem 0;
}

.card-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.card-description {
  color: #666;
  font-size: 0.9rem;
}

.service-row {
  display: flex;
  flex-wrap: wrap;
  margin-left: -0.375rem;
  margin-right: -0.375rem;
  row-gap: 0.75rem;
}

.service-col {
  flex: 0 0 25%;
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}

.service-item {
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  border: 1px solid #e8e8e8;
  transition: all 0.3s;
  cursor: pointer;
  height: 18.75rem;
}

.service-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.service-card-body {
  position: relative;
  width: 100%;
  height: 18.75rem;
}

.service-bg-mask {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.85);
  z-index: 1;
}

.service-content {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.25rem;
  text-align: center;
}

.popular-badge {
  position: absolute;
  top: 0.625rem;
  right: 0.625rem;
  background: #ff4d4f;
  color: #fff;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
  z-index: 3;
}

.service-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.service-item h3 {
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0.5rem 0;
  color: #333;
}

.service-item p {
  font-size: 0.8rem;
  color: #666;
  margin: 0.5rem 0 1rem;
  line-height: 1.5;
}

.service-price {
  font-size: 1.2rem;
  font-weight: 600;
  color: #ff4d4f;
  margin-bottom: 1rem;
}

.service-btn {
  width: 100%;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.service-btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.service-btn:active {
  transform: translateY(0);
}

/* 服务数据样式 */
.stat-row {
  display: flex;
  flex-wrap: wrap;
  margin-left: -0.375rem;
  margin-right: -0.375rem;
  row-gap: 0.75rem;
}

.stat-col {
  flex: 0 0 25%;
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  background: #fafafa;
  border-radius: 8px;
  transition: all 0.3s;
}

.stat-item:hover {
  background: #f0f0f0;
  transform: translateY(-2px);
}

.stat-icon {
  font-size: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.5rem;
}

.stat-content {
  flex: 1;
}

.stat-title {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 0.5rem;
  text-align: center;
}

.stat-value {
  font-size: 1.75rem;
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
}

.stat-value span {
  font-size: 1rem;
  margin-left: 0.25rem;
}

/* 客户评价样式 */
.testimonial-row {
  display: flex;
  flex-wrap: wrap;
  margin-left: -0.375rem;
  margin-right: -0.375rem;
  row-gap: 0.75rem;
}

.testimonial-col {
  flex: 0 0 33.333%;
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}

.testimonial-item {
  padding: 1.25rem;
  background: #fafafa;
  border-radius: 8px;
  transition: all 0.3s;
}

.testimonial-item:hover {
  background: #f0f0f0;
  transform: translateY(-2px);
}

.testimonial-header {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.testimonial-avatar {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background: #e6f7ff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
  flex-shrink: 0;
}

.testimonial-info h4 {
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 0.25rem 0;
  color: #333;
}

.testimonial-info p {
  font-size: 0.8rem;
  color: #999;
  margin: 0 0 0.5rem 0;
}

.rating {
  display: flex;
  gap: 0.25rem;
}

.testimonial-content {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.6;
  margin: 0;
}

/* 服务特色样式 */
.feature-row {
  display: flex;
  flex-wrap: wrap;
  margin-left: -0.375rem;
  margin-right: -0.375rem;
  row-gap: 0.75rem;
}

.feature-col {
  flex: 0 0 25%;
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}

.feature-item {
  padding: 1.5rem;
  background: #fff;
  border-radius: 8px;
  border-top: 3px solid;
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.feature-item:hover {
  transform: translateY(.5rem);
}

.feature-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-item h3 {
  text-align: center;
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: #333;
}

.feature-item p {
  font-size: 0.8rem;
  color: #666;
  margin: 0 0 1rem 0;
  line-height: 1.5;
}

.feature-details {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.feature-tag {
  display: inline-block;
  margin: auto;
  padding: 0.125rem 0.5rem;
  background: #e6f7ff;
  color: #1890ff;
  border-radius: 4px;
  font-size: 0.75rem;
  border: 1px solid #91d5ff;
}

/* section-title 样式 */
.section-title {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.section-title span {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
}

.section-title small {
  font-size: 0.9rem;
  color: #999;
  font-weight: normal;
}

/* 联系信息样式 */
.contact-card {
  margin: 0 0 16px 0;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.contact-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-left: -0.375rem;
  margin-right: -0.375rem;
  row-gap: 0.75rem;
}

.contact-col {
  flex: 0 0 50%;
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}

.contact-info h2 {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
}

.contact-info p {
  font-size: 0.9rem;
  margin: 0 0 1rem 0;
}

.contact-methods {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.contact-method {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
}

.contact-method svg {
  font-size: 1.1rem;
  color: #ffffff;
}

.contact-actions {
  display: flex;
  flex-direction: column;
}

.contact-btn {
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  border-radius: 24px;
  border: none;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.contact-btn-primary {
  background: #ffffff;
  color: #667eea;
  width: 100%;
}

.contact-btn-primary:hover {
  color: #fff;
  background: #1677ff;
}

.contact-btn-secondary {
  background: transparent;
  color: #ffffff;
  border: 1px solid #667eea;
  margin-top: 0.75rem;
  width: 100%;
}

.contact-btn-secondary:hover {
  background: #ffffff;
  color: #667eea;
}

.contact-btn svg {
  font-size: 1rem;
}

.floating-toolbar {
  position: fixed;
  right: 1rem;
  top: 10rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  z-index: 1000;
}

.floating-toolbar :deep(.el-button) {
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  align-self: center;
  flex-shrink: 0;
  background-color: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
}

.floating-toolbar :deep(.el-button:hover) {
  background-color: #f5f7fa;
  border-color: #409eff;
  color: #409eff;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
  transform: translateY(-2px);
}

.floating-toolbar :deep(.el-button:active) {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(64, 158, 255, 0.2);
}

.floating-toolbar :deep(.el-icon) {
  font-size: 1rem;
}

/* Right Panel Styles */
.right-panel {
  width: 18.75rem;
  flex-shrink: 0;
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.right-panel .panel-box {
  background: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.right-panel .panel-box-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #f0f0f0;
  background: #fafafa;
}

.right-panel .panel-box-header-icon {
  color: #1890ff;
}

.right-panel .panel-box-header-title {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.right-panel .panel-box-top {
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #f0f0f0;
  background: #fafafa;
}

.right-panel .panel-box-top .panel-box-title {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.right-panel .panel-box-body {
  padding: 1.25rem;
}

/* Login Prompt */
.login-prompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 1.5rem 0;
}

.login-avatar {
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  margin-bottom: 1rem;
}

.prompt-details h3 {
  font-size: 1.125rem;
  font-weight: 600;
  color: #333;
  margin: 0 0 0.5rem 0;
}

.prompt-details p {
  font-size: 0.875rem;
  color: #666;
  margin: 0 0 1.25rem 0;
}

.btn {
  padding: 0.625rem 1.25rem;
  border-radius: 0.25rem;
  border: none;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.btn-primary {
  background: #1890ff;
  color: #fff;
}

.btn-primary:hover {
  background: #40a9ff;
  transform: translateY(-1px);
  box-shadow: 0 0.25rem 0.75rem rgba(24, 144, 255, 0.3);
}

.btn-block {
  width: 100%;
}

/* Navigation List */
.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: all 0.3s;
  margin-bottom: 0.5rem;
}

.nav-item:hover {
  background: #f0f7ff;
  transform: translateX(0.25rem);
}

.nav-item:last-child {
  margin-bottom: 0;
}

.nav-icon {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.375rem;
  background: linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1890ff;
  flex-shrink: 0;
}

.nav-content {
  flex: 1;
}

.nav-title {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.25rem;
}

.nav-desc {
  font-size: 0.75rem;
  color: #999;
}

/* Hot Services */
.hot-service-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.hot-service-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 0;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.3s;
}

.hot-service-item:hover {
  background: #fafafa;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  border-radius: 0.25rem;
}

.hot-service-item:last-child {
  border-bottom: none;
}

.service-name {
  font-size: 0.875rem;
  color: #333;
}

.service-tag {
  display: inline-block;
  padding: 0.125rem 0.5rem;
  border-radius: 0.125rem;
  font-size: 0.75rem;
  font-weight: 500;
}

.service-tag-blue {
  background: #e6f7ff;
  color: #1890ff;
}

/* Customer Service */
.service-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
  padding: 1rem;
  background: linear-gradient(135deg, #f0f7ff 0%, #e6f7ff 100%);
  border-radius: 0.375rem;
}

.service-info img {
  width: 100%;
  height: 100%;
}

.service-icon {
  font-size: 2rem;
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  flex-shrink: 0;
}

.service-details h4 {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  margin: 0 0 0.25rem 0;
}

.service-details p {
  font-size: 0.8125rem;
  text-align: center;
  color: #666;
  margin: 0;
}

.btn-icon {
  font-size: 1rem;
}

/* Promise Card */
.promise-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid #f0f0f0;
}

.promise-item:last-child {
  border-bottom: none;
}

.promise-icon {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  background: #52c41a;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 0.125rem;
}

.promise-text {
  font-size: 0.875rem;
  color: #666;
  line-height: 1.5;
  flex: 1;
}
</style>

<script setup>
import {markRaw, onMounted, ref} from 'vue'
import {useRouter} from 'vue-router'
import apiClient from '@/components/plugins/axios'
import {Swiper, SwiperSlide} from 'swiper/vue'
import {Autoplay, Pagination} from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import {
  Calendar,
  CircleCheck,
  Document,
  HomeFilled,
  Location,
  Lock,
  Reading,
  Setting,
  ShoppingBag,
  StarFilled,
  SuccessFilled,
  Tools,
  User,
  UserFilled
} from '@element-plus/icons-vue'

const router = useRouter()

// 安全地使用 markRaw，如果组件为 undefined 或 null 则返回原值
const safeMarkRaw = (component) => {
  if (component == null) {
    console.warn('尝试对 undefined 或 null 使用 markRaw')
    return null
  }
  return markRaw(component)
}

// 左侧服务菜单当前激活项（使用一级分类 id 作为激活值）
const activeCategory = ref('1')

// 左侧服务菜单数据（从接口加载）
const serviceCategories = ref([])

function handleMenuSelect(index) {
  // index 形如：'categoryId' / 'categoryId-subCategoryId' / 'categoryId-subCategoryId-modelId'
  const parts = index.split('-')
  // 始终用第一个部分作为激活的一级分类 id
  activeCategory.value = parts[0]

  // 只有当选中的是第三级（具体型号）时，才跳转到下单页面
  if (parts.length === 3) {
    const [categoryIdStr, subCategoryIdStr, modelIdStr] = parts
    const categoryId = Number(categoryIdStr)
    const subCategoryId = Number(subCategoryIdStr)
    const modelId = Number(modelIdStr)

    const category = serviceCategories.value.find(cat => cat.category_id === categoryId)
    const subCategory = category?.children?.find(sub => sub.sub_category_id === subCategoryId)
    const model = subCategory?.children?.find(m => m.model_id === modelId)

    if (category && subCategory && model) {
      router.push({
        path: '/repair',
        query: {
          categoryId: String(category.category_id),
          subCategoryId: String(subCategory.sub_category_id),
          modelId: String(model.model_id)
        }
      })
    }
  }
}

// 轮播图图片列表
const carouselItems = ref([
  'https://wiseagent.oss-cn-shanghai.aliyuncs.com/website/upload/image/img_v3_02v9_d9cbd75c-cd49-41d1-a6dc-aac389b2c97g.png',
  'https://wiseagent.oss-cn-shanghai.aliyuncs.com/website/upload/image/lbt2.png'
])

// Swiper 模块
const swiperModules = [Autoplay, Pagination]

// 加载首页左侧服务分类菜单（参考 PlaceOrderView 的设备分类接口）
async function loadServiceCategories() {
  try {
    const res = await apiClient.get('/api/v1/device/category/all')
    if (res.data && res.data.code === 200) {
      const data = res.data.data || []
      // 映射3级结构：一级 category -> 二级 sub_category -> 三级 brand+model
      serviceCategories.value = data.map((category) => ({
        category_id: category.category_id,
        category: category.category,
        sort_order: category.sort_order,
        children: (category.child || []).slice(0, 5).map((subCategory) => ({
          sub_category_id: subCategory.sub_category_id,
          sub_category: subCategory.sub_category,
          sort_order: subCategory.sort_order,
          children: (subCategory.models || []).map((model) => ({
            brand_id: model.brand_id,
            brand_name: model.brand_name,
            brand_logo_url: model.brand_logo_url,
            model_id: model.model_id,
            model_name: model.model_name,
            model_url: model.model_url
          }))
        }))
      }))
      if (serviceCategories.value.length > 0) {
        activeCategory.value = String(serviceCategories.value[0].category_id)
      }
    }
  } catch (e) {
    // 接口异常时保留空菜单，不影响其他功能
  }
}

onMounted(function () {
  loadServiceCategories()
})

function goToLogin() {
  router.push('/login')
}

const services = ref([
  {
    id: 19,
    title: '自助制卡机',
    description: 'VTM、ITM、CTM、STM等自助制卡设备维修',
    price: '¥300起',
    color: 'rgb(24, 144, 255)',
    icon: safeMarkRaw(Tools),
    image: require('@/assets/images/金融设备.jpeg'),
    buttonText: '立即服务',
    isPopular: true
  },
  {
    id: 18,
    title: '桌面制卡机',
    description: 'CP500、Primacy、SUP-300等桌面制卡设备维修',
    price: '¥200起',
    color: 'rgb(82, 196, 26)',
    icon: safeMarkRaw(Setting),
    image: require('@/assets/images/办公设备.jpeg'),
    buttonText: '立即报修',
    isPopular: false
  },
  {
    id: 20,
    title: '便携制卡机',
    description: '社保卡、金融卡等便携制卡设备维修',
    price: '¥200起',
    color: 'rgb(250, 140, 22)',
    icon: safeMarkRaw(Tools),
    image: require('@/assets/images/家电维修.jpeg'),
    buttonText: '立即报修',
    isPopular: false
  },
  {
    id: 21,
    title: '纸币清分机',
    description: '提供维融清分机的专业设备维修',
    price: '¥200起',
    color: 'rgb(114, 46, 209)',
    icon: safeMarkRaw(Setting),
    image: require('@/assets/images/无人机.jpeg'),
    buttonText: '立即报修',
    isPopular: false
  }
])

const stats = ref([
  {id: 1, title: '服务用户', value: '2000', color: 'rgb(24, 144, 255)', icon: safeMarkRaw(User)},
  {id: 2, title: '成功案例', value: '2,500', color: 'rgb(82, 196, 26)', icon: safeMarkRaw(SuccessFilled)},
  {id: 3, title: '服务城市', value: '300', color: 'rgb(250, 140, 22)', icon: safeMarkRaw(Location)},
  {id: 4, title: '专业工程师', value: '5000', color: 'rgb(114, 46, 209)', icon: safeMarkRaw(Tools)}
])

const testimonials = ref([
  {id: 1, name: '张先生', company: '某制造企业', content: '智维驿的服务非常专业，工程师技术过硬，设备故障率明显降低。'},
  {id: 2, name: '李女士', company: '某银行', content: '证卡设备维修服务很贴心，价格透明，维修质量很好，推荐！'},
  {id: 3, name: '王经理', company: '某银行', content: 'ATM机维护服务很及时，设备运行稳定，客户满意度很高。'}
])

const features = ref([
  {
    id: 1,
    title: '慧维修',
    description: '专业设备故障诊断与修复服务',
    color: 'rgb(24, 144, 255)',
    icon: safeMarkRaw(Tools),
    tags: ['快速响应', '专业诊断', '质量保证']
  },
  {
    id: 2,
    title: '慧租赁',
    description: '智能设备短期租赁服务',
    color: 'rgb(82, 196, 26)',
    icon: safeMarkRaw(ShoppingBag),
    tags: ['灵活租赁', '设备齐全', '成本控制']
  },
  {
    id: 3,
    title: '慧管理',
    description: '企业设备全生命周期管理',
    color: 'rgb(250, 140, 22)',
    icon: safeMarkRaw(Setting),
    tags: ['档案管理', '维护计划', '数据分析']
  },
  {
    id: 4,
    title: '慧保养',
    description: '定期维护与预防性保养服务',
    color: 'rgb(114, 46, 209)',
    icon: safeMarkRaw(HomeFilled),
    tags: ['定期保养', '预防维护', '延长寿命']
  }
])

const navItems = ref([
  {id: 1, type: 'memberBenefits', title: '会员服务', desc: '查看专属权益', icon: safeMarkRaw(Document)},
  {id: 2, type: 'workOrder', title: '工单查询', desc: '快速查询工单', icon: safeMarkRaw(Calendar)},
  {id: 3, type: 'profile', title: '个人中心', desc: '个人信息管理', icon: safeMarkRaw(Reading)},
  {id: 4, type: 'complaint', title: '投诉热线', desc: '4008768770', icon: safeMarkRaw(UserFilled)}
])

const hotServices = ref([
  {id: 1, name: '自助制卡机', count: '128'},
  {id: 2, name: '桌面制卡机', count: '96'},
  {id: 3, name: '编写制卡机', count: '87'},
  {id: 4, name: 'ATM', count: '65'}
])

const promises = ref([
  {id: 1, text: '专业认证，技术过硬'},
  {id: 2, text: '快速响应，及时服务'},
  {id: 3, text: '质量保证，售后无忧'},
  {id: 4, text: '价格透明，诚信经营'}
])

function handleNavClick(nav) {
  if (nav.type !== 'complaint') {
    router.push('/' + nav.type)
  }
}

// 处理服务按钮点击，跳转到下单页面并自动选择金融设备的二级菜单
function handleServiceClick(id) {
  router.push({
    path: '/repair',
    query: {
      categoryId: 5,
      subCategoryId: id
    }
  })
}
</script>